import React from 'react';
import * as _ from 'lodash';
import {Button,ButtonToolbar,Modal,FormControl,Checkbox} from 'react-bootstrap'
import {Box} from 'reactjs-admin-lte';
import Sidebar from './../../asset/js/sidebar/sidebar';
import './permission.css';
import PermissionStore from '../../stores/PermissionStore';
import 'pretty-checkbox/dist/pretty-checkbox.min.css';
import FontAwesome from 'react-fontawesome'
var NotificationSystem = require('react-notification-system');
// const roles = ['stock', 'hr', 'part', 'reception', 'manager', 'md'];
// const permissions = Sidebar.data.sidebar_menu;

class PermissionTable extends React.Component {

  constructor(...props) {
    super(...props);
    this.state = {
      showPath:false,
      showPathModal:false,
      activeRoute:null,
      activeItem:{path_api_path:'',path_element_id:''},
      viewAs: '',
      permissions: {},
      roles: [],
      showUsername:false
    };
  }

  async componentDidMount() {
    const admin_config = await PermissionStore.getConfig();
    // const permissions = _.mergeWith(
    //     Sidebar.data.sidebar_menu,
    //     (admin_config.data && admin_config.data.sidebar_menu)
    //     || []
    //     , (source, target) => {
    //       if (target.render_component === source.render_component) {
    //         return target;
    //       }
    //     });
    const permissions = admin_config.data.sidebar_menu
    // console.log(permissions, Sidebar.data.sidebar_menu);
    this.setState({
      permissions,
      roles: [...this.state.roles, ...admin_config.roles] || [],
    });
  }

  viewAs = (role) => (e) => {
    if (this.state.viewAs === role) {
      this.setState({viewAs: ''});
    } else {
      this.setState({viewAs: role});
    }
  };

  saveRoles = async (e) => {
    const result = PermissionStore.saveConfig(this.state.permissions);
    // console.log(this.state.permissions, result);
    this.refs.notificationSystem.addNotification({
      title: 'บันทึกสำเร็จ',
      message: 'ทำการบันทึกเรียบร้อย ',
      level: 'info',
      position: 'tc'
    });
  };

  onRoleChange = (path, role_id) => e => {
    // console.log('toggle path:', path, ', role:', role_id, ', with', e.target.checked);

    let {permissions} = this.state;
    const route = [...path, 'role_permit'].join('.');
    let old_permit = _.get(permissions, route);

    if (e.target.checked) {
      _.set(permissions, route, _.uniq([...old_permit, role_id]));
    } else {
      _.set(permissions, route, _.without(old_permit, role_id));
    }
    // console.log('before ', old_permit, 'after', _.get(permissions, route));
    this.setState({permissions});
  };

  onPathSaveClick(){
    let {permissions,activeRoute,activeItem} = this.state;  
    const route1 = [...activeRoute, 'page_api_path'].join('.');
    const route2 = [...activeRoute, 'page_element_id'].join('.');
    const route3 = [...activeRoute, 'hash_link'].join('.');
    const route4 = [...activeRoute, 'title'].join('.');
    const route5 = [...activeRoute, 'icon'].join('.');
    const route6 = [...activeRoute, 'icon_class'].join('.');
    //console.log('api_path',api_path)

    _.set(permissions, route1, activeItem.page_api_path);
    _.set(permissions, route2, activeItem.page_element_id);
    _.set(permissions, route3, activeItem.hash_link);
    _.set(permissions, route4, activeItem.title);
    _.set(permissions, route5, activeItem.icon);
    _.set(permissions, route6, activeItem.icon_class);
    //console.log('perm',permissions,activeItem)
    this.setState({showPathModal:false,permissions})
  }

  onMenuClick(path,item){
    // console.log('menuClick',path,item)
    let {permissions} = this.state;    

    this.setState({activeRoute:path,activeItem:item,showPathModal:true})
  }

  onCheckedShowPathChange(){
    let {showPath} = this.state

    this.setState({showPath:!showPath})
  }

  _renderPermissionMenu(path, item, index) {
    const {viewAs} = this.state;
    if (viewAs
        && _.indexOf(item.role_permit, 'all') === -1
        && _.indexOf(item.role_permit, viewAs) === -1
    ) {
      return null;
    }

    const child_menus = _.map(item.child_menu, (sub_item, sub_index) => {
      return this._renderPermissionItem([...path, 'child_menu', sub_index],
          sub_item, 'sub-menu', sub_index);
    });

    return (
        <div className="permission-menu" key={index}>
          {this._renderPermissionItem([...path], item, 'menu', -1)}
          {child_menus}
        </div>
    );
  }

  renderPath(item){
    if(this.state.showPath){
      return (
        <div>[{item.hash_link}][{item.page_api_path}][{item.page_element_id}]</div>
      )
    }else{
      return ('')
    }
  }

  _renderPermissionItem(path, item, type = 'menu', index = -1) {
    const {viewAs} = this.state;
    if (viewAs
        && _.indexOf(item.role_permit, 'all') === -1
        && _.indexOf(item.role_permit, viewAs) === -1
    ) {
      return null;
    }

    const role_checkers = _.map(this.state.roles, (role, index) => {
      return this._renderRole([...path], role, index);
    });
    return (
        <div className={`permission-item ${type}`} key={index}>
          <div className="permission-menu-title" onClick={this.onMenuClick.bind(this,[...path],item)}>
            <i className={`fa fa-${item.icon} ${item.icon_class}`}></i>
            {' '}{item.title}
            {this.renderPath(item)}
          </div>
          {role_checkers}
        </div>
    );
  }

  _renderRole(path, role, index) {
    const role_permit = _.get(this.state.permissions,
        [...path, 'role_permit'].join('.'));
    const checked = _.indexOf(role_permit, role.bf_role_id) !== -1;
    const all_checked = _.indexOf(role_permit, 'all') !== -1;
    return (
        <div className="permission-role" key={index}>
          <div
              className="pretty p-svg p-jelly p-round p-bigger p-without-label">
            <input type="checkbox"
                   onChange={this.onRoleChange(path, role.bf_role_id)}
                   disabled={all_checked && role.bf_role_id !== 'all'}
                   checked={all_checked || checked} />
            <div className="state p-info">
              <svg className="svg svg-icon" viewBox="0 0 20 20">
                <path
                    d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                    style={{stroke: 'white', fill: 'white'}}></path>
              </svg>
              <label></label>
            </div>
          </div>
        </div>
    );
  }

  onShowUsernameClick() {
    let {showUsername} = this.state
    this.setState({showUsername:!showUsername})
  }

  _renderHeader(role, index) {
    const {permissionName} = this.props
    const {viewAs,showUsername} = this.state;
    const viewRole = _.find(this.state.roles, {bf_role_id: viewAs}) || {};

    const role_label = _.map(this.state.roles, (role, index) => {
      return <div className="permission-role" key={index}>
        {role.name}
        {showUsername
        ?
        <div>
          {role.user_list.map((sitem,sindex)=>{
            return(
              <span
                key={sindex}
                className={`badge label-success`}
              >
                <small>{sitem.name}</small>
              </span>
            )
          })}
        </div>
        :''}
        <div>
          <span
              className={`badge ${viewAs === role.bf_role_id
                  ? 'badge-primary' : 'badge-default'}`}
              onClick={this.viewAs(role.bf_role_id)}>
            <small>view as</small>
          </span>
        </div>
      </div>;
    });
    return (
        <div className="permission-menu" key={-1}>
          <div className="permission-item header">
            <div className="permission-menu-title">
              Role 
              <span
                className={`badge ${this.state.showPath
                ? 'badge-primary' : 'badge-default'}`}
                onClick={this.onCheckedShowPathChange.bind(this)}>
                <small>show path</small>
              </span>
              {permissionName==='sidebar_menu'
              ?
              <div className='text-center'>
                <Button bsSize='xs' onClick={this.onShowUsernameClick.bind(this)}><FontAwesome name='user' /> Show user</Button>   
              </div>
              :''}    
              <div>
                {viewAs ? ` (view as ${viewRole.name})` : null}
              </div>
            </div>
            {role_label}
          </div>
        </div>
    );
  }

  renderPathApiModal(){
    let {activeItem} = this.state
    let {title,icon,icon_class} = activeItem 
    return (
      <Modal show={this.state.showPathModal} enforceFocus={false} onHide={()=>{this.setState({showPathModal:false})}} dialogClassName="smallwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>ตั้งค่า Path</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-bordered table-hover table-striped'>
                <thead><tr><th>Hash Link</th><th>API Path</th><th>Element ID</th></tr></thead>
                <tbody>
                  <tr>
                    <td>
                      <FormControl onChange={(e)=>{let {activeItem} = this.state; activeItem.hash_link = e.target.value; this.setState({activeItem:activeItem})}} value={activeItem.hash_link}/>
                    </td>
                    <td>
                      <FormControl onChange={(e)=>{let {activeItem} = this.state; activeItem.page_api_path = e.target.value; this.setState({activeItem:activeItem})}} value={activeItem.page_api_path}/>
                    </td>
                    <td>
                    <FormControl onChange={(e)=>{let {activeItem} = this.state; activeItem.page_element_id = e.target.value; this.setState({activeItem:activeItem})}} value={activeItem.page_element_id}/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='table-responsive'>
              <table className='table table-bordered table-hover table-striped'>
                <thead><tr><th>Icon</th><th>Icon Class</th><th>Title</th></tr></thead>
                <tbody>
                  <tr>
                    <td>
                      <FormControl onChange={(e)=>{let {activeItem} = this.state; activeItem.icon = e.target.value; this.setState({activeItem:activeItem})}} value={activeItem.icon} /></td>
                    <td>
                      <FormControl onChange={(e)=>{let {activeItem} = this.state; activeItem.icon_class = e.target.value; this.setState({activeItem:activeItem})}} value={activeItem.icon_class} />
                    </td>
                    <td>
                      <FormControl onChange={(e)=>{let {activeItem} = this.state; activeItem.title = e.target.value; this.setState({activeItem:activeItem})}} value={activeItem.title} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> 
            {
              title!=''||icon!=''
              ?<div style={{fontWeight:'bold'}}>Preview&nbsp;<span style={{border:'1px solid #ddd',padding:'10px',display:'inline'}}><i className={'fa fa-'+icon+' '+icon_class}></i>&nbsp;{title}&nbsp;</span></div>
              :''
            } 
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.onPathSaveClick.bind(this)}><FontAwesome name='save'/>&nbsp;บันทึก</Button>
          </Modal.Footer>
       </Modal>
    )
  }

  render() {

    const table = _.map(this.state.permissions, (item, index) => {
      return this._renderPermissionMenu([index], item, index);
    });

    return (
      <Box>
        <Box.Body>
          <div className="table-responsive">          
            <div className="permission-table">
              {this._renderHeader()}
              {table}
              <ButtonToolbar className='pull-right' style={{marginTop:'25px',display:'inline-block'}} > 
                <Button bsStyle='primary' onClick={this.saveRoles}><FontAwesome name='save'/>&nbsp;บันทึก</Button>
              </ButtonToolbar>
            </div>
          </div>
          {this.renderPathApiModal()}
        </Box.Body>       
        <NotificationSystem ref="notificationSystem" /> 
      </Box>        
    );
  }

}

class RoleItem extends React.Component {

  render() {
    return (<div>

    </div>);
  }

}

PermissionTable.defaultProps = {
  permissionName:'sidebar_menu'
}

export default PermissionTable;

// const mapStateToProps = (state) => {
//
// };

// export default connect(state => state)(PermissionTable);


// WEBPACK FOOTER //
// ./src/view/permission/PermissionTable.js